<template>
<div class="sm:hidden mt-5">
    <div class="flex justify-center rounded-full pt-2 h-16 menu-mobile bg-white sm:hidden">
        <MenuItem :label="lbl.bottom_bar.home"
                  url="/home"
                  :isActive="activeMenu == 'home'">
            <img v-if="activeMenu == 'home'" class="w-8 mx-auto" src="@/assets/menu/menu-home-active.svg">
            <img v-else class="w-8 mx-auto" src="@/assets/menu/menu-home-inactive.svg">
        </MenuItem>
        <!-- /privilege -->
        <MenuItem :label="lbl.bottom_bar.reward"
                  url="/privilege"
                  :isActive="activeMenu == 'privilege'">
            <img v-if="activeMenu == 'privilege'" class="w-8 mx-auto" src="@/assets/menu/menu-privilege-active.svg">
            <img v-else class="w-8 mx-auto" src="@/assets/menu/menu-privilege-inactive.svg">
        </MenuItem>
        <!-- /mission -->
        <MenuItem :label="lbl.bottom_bar.mission"
                  url="/mission"
                  v-if="showMissionMenu()"
                  :isActive="activeMenu == 'mission'">
            <img v-if="activeMenu == 'mission'" class="w-8 mx-auto" src="@/assets/menu/menu-mission-active.svg">
            <img v-else class="w-8 mx-auto" src="@/assets/menu/menu-mission-inactive.svg">
        </MenuItem>
        <MenuItem :label="lbl.bottom_bar.profile"
                    url="/profile"
                    :isActive="activeMenu == 'profile'">
            <img v-if="activeMenu == 'profile'" class="w-7 mx-auto pt-5px" src="@/assets/menu/menu-profile-active.png">
            <img v-else class="w-8 mx-auto" src="@/assets/menu/menu-profile-inactive.svg">
        </MenuItem>
    </div>
</div>
</template>
<script>
import MenuItem from "./component/MenuItem.vue";
import LocaleMixin from '@/mixin/LocaleMixin';
import { UserLevel } from '@/core/UserLevel/UserLevel'

export default {
    name: 'MenuMobile',
    mixins: [LocaleMixin],
    components: {
        MenuItem,
    },
    props: {
        activeMenu: { type: String, required: true },
        customClass:   { type: String, default: '' },
        userData:  Object,
    },
    methods:{
        showMissionMenu: function(){
            let userLvl = new UserLevel();
            if(userLvl.isRegistered() || userLvl.isBronze() || userLvl.isSilver() || userLvl.isGold() || userLvl.isPlatinum()){
                return true
            }
            return false
        }
    }

}
</script>
<style lang="scss" scoped>
.menu-mobile{
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
</style>
